import { useState } from 'react';
import Link from 'next/link';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import CloudinaryImage from '../common/CloudinaryImage';

export default function PodCastSubscribe({
  subscribe,
  classAtt,
  grid,
  font,
  btn,
}) {
  // const [dropDown, setDropDown] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const handleMouseEnter = () => setIsActive(true);
  const handleMouseLeave = () => setIsActive(false);

  return (
    <div className={classAtt}>
      <div className={`grid ${grid}`}>
        <div className="flex items-center flex-wrap">
          {subscribe?.titleEditor && (
            <ReactMarkdown
              rehypePlugins={[rehypeRaw]}
              className={` ${font} leading-tight`}
              source={subscribe?.titleEditor}
            >
              {subscribe?.titleEditor}
            </ReactMarkdown>
          )}
        </div>
        <div className="flex flex-wrap items-center">
          <div
            className="relative w-full"
            onMouseOver={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <button className={btn}>{subscribe?.btn_text}</button>
            {isActive && (
              <ul
                className={`bg-[#ffffff] rounded-[3px] shadow-[0px_0px_20px_0px_#0000001A] w-full absolute z-[1] `}
              >
                {subscribe?.List?.map((img, key) => (
                  <li key={key}>
                    <Link
                      href={`${img?.link ? img?.link : ''}`}
                      className={'hover:bg-[#ddd] px-4 py-3 block'}
                    >
                      <CloudinaryImage
                        backendImgUrl={img?.image?.data?.attributes?.url}
                        alt={img?.image?.data?.attributes?.alternativeText}
                        className="h-[30px]"
                        type={'icon'}
                      />
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
